import { render, staticRenderFns } from "./create-product.vue?vue&type=template&id=6c1bb313&scoped=true&"
import script from "./create-product.vue?vue&type=script&lang=js&"
export * from "./create-product.vue?vue&type=script&lang=js&"
import style0 from "./create-product.vue?vue&type=style&index=0&id=6c1bb313&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1bb313",
  null
  
)

export default component.exports